import { IConfig } from "./Render";
export const Tbody = ({className, id, children}:IConfig)=>
{
    return (
        <tbody id={id} className={className}>{children}</tbody>
    );
}